<app-component-level-error-message [errorMessage]="errorMessage"></app-component-level-error-message>

@if (uiState === uiStateForTemplate.ShowLoading) {
  <app-loading-card-content></app-loading-card-content>
} @else if (uiState === uiStateForTemplate.ShowData && pricePointReport) {
  <div class="margin-top-large">
    <div class="justify-space-between flex-row align-start">
      <div>
        <div class="section-header">Sales Summary by Price Point Report</div>
        <div class="ticket-type-header">Date Range:</div>
        {{ dateRanges.StartDate | date: 'MMM d, y HH:mm' }} -
        {{ dateRanges.EndDate | date: 'MMM d, y HH:mm' }}
      </div>
    </div>

    <div class="margin-top-large">
      <h3>Sales Summary</h3>
      <div class="margin-left-med">
        <div class="margin-top-med">
          <div class="report-label">Total Tickets Sold</div>
          <div class="report-value"
               data-testid="price-point-total-tickets">{{ pricePointReport.TotalTicketStripsSold }}
          </div>
        </div>
        <div>
          <div class="report-label bold-text">Total Sales Value</div>
          <div class="report-value bold-text"
               data-testid="price-point-total-value">{{ pricePointReport.TotalSalesValue | formatCurrency }}
          </div>
        </div>
      </div>

      <h3>Sales Breakdown by Price Point</h3>
      <ag-grid-angular
        class="ag-theme-quartz margin-top-med margin-left-med"
        data-testid="price-point-breakdown-table"
        [animateRows]="true"
        [domLayout]="'autoHeight'"
        overlayNoRowsTemplate="<span>No sales data for this date range</span>"
        [rowData]="pricePointReport.PricePointBreakdown"
        [columnDefs]="pricePointReportDefs">
      </ag-grid-angular>
    </div>
  </div>
}
